window.onload = () => {
    // get all a tags with /request-a-demo/ or #demo-form in the href with or without the trailing slash
    const startPlanningModalLinks = document.querySelectorAll(
        'a[href*="/start-planning"],a[href*="#start-planning"]'
    );

    startPlanningModalLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            window.dispatchEvent(new CustomEvent("startplanningmodalopen"));
            window.dispatchEvent(new CustomEvent("pegasus-start-planning-open"));
        });
    });
};

document.addEventListener("alpine:init", () => {
    Alpine.data("startPlanningModal", () => ({
        open: false,
        currentImage: 'yellow-canyon',
        init() {

            window.addEventListener("pegasusformlocationupdate", e => {
                this.currentImage = 'locations/'+e.detail;
            })

        },
        closeStartPlanning() {
            this.open = false;
            window.dispatchEvent(new CustomEvent("pegasus-start-planning-close"));
        },
    }));
});
